// extracted by mini-css-extract-plugin
module.exports = {"root":"ResetPasswordPage_root__23oLe","isResetPassword":"ResetPasswordPage_isResetPassword__3VXfN"};